import { createSlice } from '@reduxjs/toolkit';

export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    showMenu: false,
  },
  reducers: {
    toggleShowMenu: (state) => {
      state.showMenu = !state.showMenu;
    },
  },
});

export const { toggleShowMenu } = menuSlice.actions;

export default menuSlice.reducer;
